import React, { useEffect } from 'react';

const AdSenseUnit = ({ slot = 'auto', format = 'auto', responsive = true, style = {} }) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle && process.env.NODE_ENV !== 'development') {
        (window.adsbygoogle = window.adsbygoogle || [])?.push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, []);

  const adsenseId = import.meta.env?.VITE_ADSENSE_ID;

  if (!adsenseId || adsenseId === 'your-adsense-id-here') {
    return null;
  }

  return (
    <div className="w-full my-6 md:my-8 flex justify-center">
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          textAlign: 'center',
          minHeight: '90px',
          ...style
        }}
        data-ad-client={adsenseId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive?.toString()}
      ></ins>
    </div>
  );
};

export default AdSenseUnit;